import { IFormValidation } from '@aston/foundation';

export class IUpdateFederationValidator implements IFormValidation {
	ruleset = 'updateFederationCommandValidator';
	fields = {
		Name: 'Name',
		CurrencyCode: 'CurrencyCode',
		SubsidiaryIds: 'SubsidiaryIds',
		WithCustomersAggregated: 'WithCustomersAggregated',
	};
}

export const UpdateFederationValidator = new IUpdateFederationValidator();
